export default __webpack_public_path__ + "static/media/266.6caa7ec5.gif";